<div class="flex flex-col justify-end items-center bg-red-300 rounded-lg" [ngClass]="{ 'pointer-events-none': disabled }">
  <button
    [disabled]="disabled"
    (click)="onClick()"
    class="rounded-lg flex items-center text-white p-2 cursor-pointer transition-colors duration-200"
    [ngClass]="[
      disabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-' + color,
      disabled ? '' : 'hover:bg-' + color.replace('500', '600')
    ]"
  >
    <i [class]="icon + ' text-base flex items-center'"></i>
    <span class="ml-2">{{ label }}</span>
  </button>
</div>
